import {base64Decode} from "@/library/utilities/base64"

export type DecodedJwt = {
    header: {
        alg: string
        typ: string
    }
    payload: {[key: string]: any}
    signature: string
}


export const parseJwt = (input: string): DecodedJwt => {
    //console.log(input)

    const parts = input.split(".")
    if (parts.length < 3)
        throw new Error("Expected JWT to contain 3 parts separated by a period")

    const encoded = {
        header: parts[0],
        payload: parts[1]
    }

    return {
        header: base64Decode(encoded.header),
        payload: base64Decode(encoded.payload),
        signature: parts[2]
    }
}
